/* unplugin-vue-components disabled */import script from "./data2.vue?vue&type=script&setup=true&lang=js"
export * from "./data2.vue?vue&type=script&setup=true&lang=js"

import "./data2.vue?vue&type=style&index=0&id=feb4403e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-feb4403e"]])

export default __exports__